// extracted by mini-css-extract-plugin
export default {"overlayicon":"overlayicon_overlayicon__qTF0v","overlayiconselected":"overlayicon_overlayiconselected__rnmZM","overlayiconmobile":"overlayicon_overlayiconmobile__Iws98"};